import { render } from "./WriteOffComponent.vue?vue&type=template&id=96cd766c"
import script from "./WriteOffComponent.vue?vue&type=script&lang=js"
export * from "./WriteOffComponent.vue?vue&type=script&lang=js"

import "@/assets/styles/billing/writeOff.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__